import { render } from "./Vox Cinema.vue?vue&type=template&id=70749d18&scoped=true"
const script = {}

import "./Vox Cinema.vue?vue&type=style&index=0&id=70749d18&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70749d18"

export default script